/* eslint react-hooks/exhaustive-deps: "warn" */

import Image from 'next/image';

import { Section } from 'ui/molecules/Section/Section';

import styles from './WhereWeAre.module.scss';

interface Office {
  cc: string;
  country: string;
  city: string;
  role: string;
  entity: string;
  use: string;
  address: string[];
  reg: { label: string; value: string }[];
}

const OFFICES: Office[] = [
  {
    cc: 'gb',
    country: 'United Kingdom',
    city: 'Northampton',
    role: 'Headquarters. Commercial, customer and group functions.',
    entity: 'Global Data Intelligence Limited',
    use: 'Contract with this entity if you are buying from the UK, the EU or the rest of the world.',
    address: ["Artisans' House, 7 Queensbridge", 'Northampton, Northamptonshire NN4 7BF', 'United Kingdom'],
    reg: [
      { label: 'Registered at Companies House', value: '09410808' },
      { label: 'VAT', value: 'GB260423730' },
    ],
  },
  {
    cc: 'us',
    country: 'United States',
    city: 'Delaware',
    role: 'North American entity. Serving US and Canadian enterprise customers.',
    entity: 'Global Database North America Inc.',
    use: 'Contract with this entity if you are buying from the United States or Canada. A Delaware C-corporation, so US procurement and tax teams have nothing new to learn.',
    address: ['1111B S Governors Ave, STE 23296', 'Dover, DE 19904', 'United States'],
    reg: [
      { label: 'Delaware C-corporation · File no.', value: '5306480' },
      { label: 'EIN', value: '61-2217262' },
    ],
  },
  {
    cc: 'md',
    country: 'Moldova',
    city: 'Chișinău',
    role: 'Engineering and data operations. Where the registry pipeline is built, run and monitored.',
    entity: 'Global Database SRL',
    use: 'This is where the registry pipeline is built, run and watched — the engineering that keeps 400+ sources alive.',
    address: ['Columna 170/C, Buiucani', 'MD-2004, Chișinău', 'Republic of Moldova'],
    reg: [{ label: 'Moldova IT Park resident · IDNO', value: '1021600025805' }],
  },
];

export const WhereWeAre = () => (
  <Section
    align="left"
    title="Where we are"
    description="Where the company is legally registered, and which entity to contract with."
  >
    <div className={styles.inner}>
      {OFFICES.map((office) => (
        <div key={office.cc} className={styles.office}>
          <div className={styles.officeId}>
            <div className={styles.officeHead}>
              <Image
                className={styles.flag}
                src={`/storage/flags/${office.cc}.svg`}
                alt={office.country}
                width={44}
                height={32}
                unoptimized
              />
              <span className={styles.country}>{office.country}</span>
            </div>
            <div className={styles.city}>{office.city}</div>
            <p className={styles.role}>{office.role}</p>
          </div>

          <div className={styles.panel}>
            <div className={styles.panelTop}>
              <span className={styles.entityLabel}>Legal entity</span>
              <div className={styles.entity}>{office.entity}</div>
            </div>
            <p className={styles.use}>{office.use}</p>
            <address className={styles.address}>
              {office.address.map((line, i) => (
                <span key={i}>
                  {line}
                  {i < office.address.length - 1 && <br />}
                </span>
              ))}
            </address>
            <div className={styles.reg}>
              {office.reg.map((r, i) => (
                <span key={r.label}>
                  {i > 0 && <>&nbsp;·&nbsp;</>}
                  {r.label}&nbsp;·&nbsp;<b>{r.value}</b>
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </Section>
);
